<template lang='pug'>
    v-container#wizard(tag="section").pa-0
      validation-observer(v-slot="{ valid }")
        base-material-wizard.mx-auto(v-model="tab" :available-steps="availableSteps" :items="tabs" @click:next="next(valid)" @click:prev="back(valid)")
          v-tab-item.pb-12
            // First
            form
              .text-center.display-1.font-weight-light.mb-6
                | {{$t('profile.wizard.titles.information')}}
              v-row.mx-auto(justify="space-around" style="max-width: 500px;")
                v-col.text-center(cols="12" md="6")
                  input.d-none(ref="file" type="file" @change="onChange")
                  v-card.mx-auto.mt-0.d-inline-flex.v-card--account(:class="image ? 'success--text' : 'grey--text'" outlined="" height="106" width="106" @click="$refs.file.click()")
                    v-img(v-if="image" :src="image" height="100%" width="100%")
                    v-icon.mx-auto(v-else="" size="96")
                      | mdi-account
                  .font-weight-bold.grey--text
                    | {{$t('profile.wizard.information.picture')}}
                v-col(cols="12" md="6")
                  validation-provider(v-slot="{ errors }" rules="required" name="first")
                    v-text-field(v-model="first" :error-messages="errors" color="secondary" :label="$t('profile.wizard.information.firts_name')" prepend-icon="mdi-face" validate-on-blur="")
                  validation-provider(v-slot="{ errors }" rules="required" name="last")
                    v-text-field(v-model="last" :error-messages="errors" color="secondary" :label="$t('profile.wizard.information.last_name')" prepend-icon="mdi-account" validate-on-blur="")
                  validation-provider(v-slot="{ errors }" rules="required" name="identification")
                    v-text-field(v-model="identification" :error-messages="errors" color="secondary" label="Número de identification" prepend-icon="mdi-account" validate-on-blur="" type="number")
                v-col(cols="12" md="6")
                  validation-provider(v-slot="{ errors }" rules="required" name="phone")
                    v-text-field(v-model="phone" :error-messages="errors" color="secondary" :label="$t('profile.wizard.information.phone')" prepend-icon="mdi-phone" validate-on-blur="" type="number")
                v-col(cols="12" md="6").ml-0
                  validation-provider(v-slot="{ errors }" rules="required" name="email")
                    v-text-field(v-model="email" :error-messages="errors" color="secondary" :label="$t('profile.wizard.information.notification_email')" prepend-icon="mdi-email" validate-on-blur="")
          v-tab-item.pb-12
            .text-center.display-1.grey--text.font-weight-light.mb-6
              | {{$t('profile.wizard.titles.direction')}}
            form
              // Second
              v-row.mx-auto(style="max-width: 500px;")
                v-col(cols="12")
                  validation-provider(v-slot="{ errors }" rules="required" name="address")
                    v-text-field(v-model="address" :error-messages="errors" color="secondary" :label="$t('profile.wizard.street.name')" validate-on-blur="")
                //-
                  v-col(cols="12" md="4")
                    validation-provider(v-slot="{ errors }" rules="required" name="street")
                      v-text-field(v-model="street" :error-messages="errors" color="secondary" :label="$t('profile.wizard.street.number')" validate-on-blur="")
                v-col(cols="12" md="6")
                  validation-provider(v-slot="{ errors }" rules="required" name="city")
                    v-text-field(v-model="city" :error-messages="errors" color="secondary" :label="$t('profile.wizard.street.city')" validate-on-blur="")
                v-col(cols="12" md="6")
                  validation-provider(v-slot="{ errors }" rules="required" name="state")
                    v-text-field(v-model="state" :error-messages="errors" color="secondary" :label="$t('profile.wizard.street.state')" validate-on-blur="")
                    // v-autocomplete(v-model="state" :autocomplete="Date.now()" :error-messages="errors" :items="states" color="secondary" label="State*" validate-on-blur="")
                v-col(cols="12" md="6")
                  validation-provider(v-slot="{ errors }" rules="required" name="country")
                    v-select(v-model="country" :items="countries" :error-messages="errors" color="secondary" label="Pais" validate-on-blur="")
</template>

<script>
  import firebase from 'firebase'
  import { countries } from '@/locales/countries.json'
  export default {
    name: 'DashboardFormsWizard',

    data: () => ({
      countries: countries,
      account: [],
      accounts: [
        {
          icon: 'mdi-pencil',
          type: 'Administrador',
        },
        {
          icon: 'mdi-code-tags',
          type: 'Colaborador',
        },
      ],
      address: '',
      city: '',
      email: '',
      first: '',
      image: null,
      last: '',
      identification: '',
      country: '',
      state: '',
      states: [
        'Alabama', 'Alaska', 'American Samoa', 'Arizona',
        'Arkansas', 'California', 'Colorado', 'Connecticut',
        'Delaware', 'District of Columbia', 'Federated States of Micronesia',
        'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho',
        'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
        'Louisiana', 'Maine', 'Marshall Islands', 'Maryland',
        'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
        'Missouri', 'Montana', 'Nebraska', 'Nevada',
        'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
        'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio',
        'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico',
        'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee',
        'Texas', 'Utah', 'Vermont', 'Virgin Island', 'Virginia',
        'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
      ],
      // street: '',
      phone: '',
      tab: 0,
      tabs: ['Contacto', 'Dirección'],
      type: '',
      types: ['Individual', 'Empresa'],
      goBack: false,
    }),

    computed: {
      plan_reactivate () {
        return this.$store.state.payment.plan_reactivate
      },
      userData () {
        return firebase.auth().currentUser
      },
      stringAccount () {
        // console.log(this.account)
        return this.account.join(',')
      },
      scope () {
        if (this.tab === 0) return 'Contacto'
        else if (this.tab === 1) return 'Dirección'
        return 'Contacco'
      },
      availableSteps () {
        const steps = [0]

        if (
          this.first &&
          this.last &&
          this.validForm() &&
          this.email
        ) steps.push(1)

        if (
          this.address &&
          // this.street &&
          this.city &&
          this.state &&
          steps.includes(1)
        ) steps.push(2)

        return steps
      },
    },

    mounted () {
      const vm = this
      // console.log(vm.$store.state.users.user)
      vm.country = vm.$store.state.users.registerCountry
      if (vm.$store.state.users.user.role) {
        if (vm.$store.state.users.user.country === 'MÃ©xico') {
          vm.country = 'México'
        } else {
          vm.country = vm.$store.state.users.user.country
        }
      }
      // console.log(vm.country, 'the country')
      if (vm.userData) {
        // console.log(vm.userData)
        vm.first = vm.userData.providerData[0].displayName || ''
      }
    },

    methods: {
      validForm () {
        const vm = this
        let valid = true
        const regexEmailTest = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(vm.email)
        if (vm.phone.length > 0) {
          valid = /^\d+$/.test(vm.phone)
        }
        if (regexEmailTest && valid && vm.first && vm.last && vm.identification) {
          return true
        } else {
          return false
        }
      },
      next (valid) {
        // console.log(valid, this.goBack)
        if (!valid && !this.goBack) return valid
        if (this.tab === this.tabs.length - 1) {
          this.save()
        } else if ((!valid && this.goBack) || (valid && !this.goBack)) {
          this.goBack = false
          this.tab++
        } else if (valid) {
          this.goBack = false
          this.tab++
        }
      },
      back (valid) {
        this.goBack = true
        this.tab--
      },
      onChange (val) {
        const value = val.target.files[0]

        if (!value) return (this.image = null)

        this.image = URL.createObjectURL(value)
      },
      save () {
        const vm = this
        const profileData = {
          name: vm.first,
          last_name: vm.last,
          notification_email: vm.email,
          phone: vm.phone,
          identification: vm.identification,
          type: vm.type,
          direction: {
            address: vm.address,
            // street: vm.street,
            city: vm.city,
            state: vm.state,
            country: vm.country,
          },
          restrictions: { ...vm.plan_reactivate.data.restrictions },
        }
        const dataSubscription = {
          id_plan: vm.plan_reactivate.data.id_plan,
          restrictions: vm.plan_reactivate.data.restrictions,
          shops: [],
          collaborators: [],
        }
        vm.$store.dispatch('payment/createSubscription', dataSubscription).then(() => {
          // subscripcion creada
        })
        vm.$store.dispatch('users/updateProfile', profileData).then(function (res) {
          // ejecutar si es valido el link de referido
          if (vm.$store.state.referrals.referralsOwnerCode !== '') {
            const referralObj = {
              referralId: vm.$store.state.users.user.uid,
              email: vm.$store.state.users.user.email,
              referralCode: vm.$store.state.referrals.referralsOwnerCode.toUpperCase(),
              name: vm.first,
              last_name: vm.last,
              phone: vm.phone,
              log: {
                commission: 0,
                cost: 0,
                plan: 'Plan Reactivate',
                type: 'month',
              },
              action: 'add',
              subaction: 'addFirstlogRegister',
            }
            vm.$store.dispatch('referrals/codeValidator', referralObj).then(res => {
              vm.$store.commit('referrals/SET_REFERRAL_OWNERCODE', '')
            })
          }
          vm.$emit('close')
          vm.$store.dispatch('users/loadProfile')
          /* if (vm.$store.state.subscriptions.selectedPlan) {
            /* vm.$store.dispatch('subscriptions/setSubscriptionDialog', true).then(function () {
              vm.$emit('close')
            })
          } else {
          } */
        })
      },
    },
  }
</script>

<style lang="sass">
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

    .v-icon
      color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%

</style>
